import React from "react";
import PropTypes from "prop-types";

const FastForward = ({ fillColor, customStyles }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="10.19"
			height="7.702"
			viewBox="0 0 10.19 7.702"
			style={customStyles}
		>
			<path
				id="icon-ff"
				d="M5.669,4.632V7.7L0,3.851,5.669,0V3.07L10.19,0V7.7Z"
				transform="translate(10.19 7.702) rotate(180)"
				fill={fillColor}
			/>
		</svg>
	);
};

FastForward.propTypes = {
	fillColor: PropTypes.string.isRequired,
	customStyles: PropTypes.object
};

FastForward.defaultProps = {
	fillColor: "#000000"
};

export default FastForward;
